import { Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-admin';

import { ConfigurationIssue } from '../../../graphql/types';
import { BORDER_GRAY } from '../../../theme';

export const ConfigurationIssueItem: React.FC<{
  issue: ConfigurationIssue;
}> = ({ issue }) => {
  const { title, description, link } = issue;
  return (
    <div
      style={{
        border: `1px solid ${BORDER_GRAY}`,
        borderRadius: 4,
        padding: 16,
        marginBottom: 16,
      }}
    >
      <Typography variant="subtitle2">{title}</Typography>
      <p>{description}</p>
      {link && (
        <Link to={link} target="_blank" color="primary">
          Link
        </Link>
      )}
    </div>
  );
};
